// import Swiper from 'swiper/bundle';
// var swiper = new Swiper('.swiper-container01', {

import { _ticker } from 'gsap/gsap-core';
import slick from 'slick-carousel';
//import lightbox2 from 'lightbox2/dist/js/lightbox-plus-jquery.js';

var $ = require('jquery');

$(document).ready(function(){
	// lightbox.option({
	// 	'resizeDuration': 200,
	// 	'wrapAround': true,
	// 	'disableScrolling': true
	// });
	//TOP
	$('.slider-sitelink').slick({
		infinite: true,
		slidesToShow: 4,
		arrows: false,
		centerPadding: '40px',
		responsive: [
			{
				breakpoint: 768,
				settings: {
					arrows: true,
					centerMode: true,
					centerPadding: '40px',
					slidesToShow: 1,
					autoplay: true,
				  autoplaySpeed: 2000,
				}
			},
			{
				breakpoint: 480,
				settings: {
					arrows: true,
					centerMode: true,
					centerPadding: '40px',
					autoplay: true,
					slidesToShow: 1
				}
			}
		]
	});

	//https://help.thebase.in/hc/ja/articles/900000108823
	$('.slide-itemlist').slick({
		infinite: true,
		centerMode: true,
		slidesToShow: 3,
		arrows: true,
		autoplay: true,
		responsive: [
			{
				breakpoint: 835,
				settings: {
					arrows: true,
					centerMode: true,
					centerPadding: '5px',
					slidesToShow: 3,
					autoplay: true,
					autoplaySpeed: 2000,
				}
			},
			{
				breakpoint: 576,
				settings: {
					arrows: true,
					centerMode: true,
					centerPadding: '80px',
					slidesToShow: 1
				}
			},
			{
				breakpoint: 420,
				settings: {
					arrows: true,
					//centerMode: true,
					//centerPadding: '0px',
					slidesToShow: 1
				}
			},
			{
				breakpoint: 376,
				settings: {
					arrows: true,
					centerMode: true,
					centerPadding: '10px',
					slidesToShow: 1
				}
			}
		]
	});

	//RACE
	$('.slider-ready').slick({
		infinite: true,
		slidesToShow: 3,
		arrows: false,
		responsive: [
			{
				breakpoint: 770,
				settings: {
					infinite: true,
					slidesToShow: 3,
					arrows: false,
				}
			},
			{
				breakpoint: 767.98,
				settings: {
					arrows: true,
					//centerMode: true,
					//centerPadding: '40px',
					slidesToShow: 1
				}
			},
			{
				breakpoint: 480,
				settings: {
					arrows: true,
					//centerMode: true,
					//centerPadding: '40px',
					slidesToShow: 1
				}
			}
		]
	});

});

//youtube
$(document).ready(function(){
	autoPlayYouTubeModal();
	// Remove iframe attributes when the modal has finished being hidden from the user
	$("#exampleModalCenter").on("hidden.bs.modal", function() {
		$("#exampleModalCenter iframe").removeAttr("src allow");
		//console.log("チェック02");
	});
});

function autoPlayYouTubeModal(){
	var trigger = $("body").find('[data-toggle="modal"]');
	trigger.click(function() {
		var theModal = $(this).data( "target" ),
		videoSRC = $(this).attr( "data-theVideo" ),
		videoSRCauto = videoSRC+"?autoplay=1" ;
		$(theModal+' iframe').attr('src', videoSRCauto);
		$(theModal+' button.close').click(function () {
			$(theModal+' iframe').attr('src', videoSRC);
		});
		//console.log("video");
	});
};

//scroll animation
window.onload = function() {

	// テキストを<span></span>で囲む
	// $('.h2effect').children().addBack().contents().each(function() {
	// 	if (this.nodeType == 3) {
	// 		$(this).replaceWith($(this).text().replace(/(\S)/g, '<span>$1</span>'));
	// 	}
	// });
	//lightbox_with();
	loading_effect();

	$(window).scroll(function(){
		scroll_effect();
		scroll_effect2();
		scroll_effect3();		
	});

	var scrollHeight = $(document).height(); //ドキュメントの高さ 
	var scrollPosition = $(window).height() + $(window).scrollTop(); //現在地 
	var captureHeight = $(".grecaptcha-badge").innerHeight();
	var captureHeight = 0;
	var footHeight = $("#footercontact").innerHeight() + $("#page-footer").innerHeight() + captureHeight + 14; //止めたい位置の高さ
	
	if (scrollHeight - scrollPosition <= footHeight) { //ドキュメントの高さと現在地の差がfooterの高さ以下の時
		$(".grecaptcha-badge").css({
			"position": "absolute", //pisitionをabsoluteに変更
			"bottom": footHeight + "px",
		});
	} else { //それ以外の場合は
		$(".grecaptcha-badge").css({
			"position": "fixed", //固定表示
			"bottom": "14px",
		});
	}

	function loading_effect(){
		$("body").addClass("in-load");
        if((localStorage.getItem('loading') === null) || (localStorage.getItem('loading') != "1")){
            setTimeout( function(){ $('#loading_bg').fadeIn(800);},100); //0.5秒後にロゴをフェードイン!
            setTimeout( function(){ $('#loading_text').fadeIn(2000);},800); //0.8秒後にロゴをフェードイン!
            setTimeout (function(){ $('#loading').fadeOut(1000); },3500); //3.5秒後にロゴ含め真っ白背景をフェードアウト！
            localStorage.setItem('loading',"1");
        } else {
            setTimeout (function(){ $('#loading').fadeOut(500); },500); //3.5秒後にロゴ含め真っ白背景をフェードアウト！
        };
    }

	//ウィンドウサイズ変更時に更新
	//window.onresize = lightbox_with();
	
	function scroll_effect(){
		$('.start').each(function(){
			var elemPos = $(this).offset().top;
			var scroll = $(window).scrollTop();
			var windowHeight = $(window).height();
			if (scroll > elemPos - windowHeight/2 ){
				$(this).addClass($(this).data('effect'));
				document.getElementById('panime').contentWindow.exportRoot.gotoAndPlay('movieClip_1',1);
				// var effect = $(this).data('effect');
			}
		});
	};

	function scroll_effect2(){
		$('.effect').each(function(){
			var elemPos2 = $(this).offset().top;
			var scroll = $(window).scrollTop();
			var windowHeight = $(window).height();
			if (scroll > elemPos2 - windowHeight+50 ){
				$(this).addClass($(this).data('effect'));
				var effect = $(this).data('effect');
			}
		});
	};

	function scroll_effect3(){
		$('.h2effect').each(function(){
			var elemPos3 = $(this).offset().top;
			var scroll = $(window).scrollTop();
			var windowHeight = $(window).height();
			if (scroll > elemPos3 - windowHeight+100 ){
				$(this).addClass($(this).data('effect'));
				var effect = $(this).data('effect');
				//一文字ずつフェードインさせる
				//$('.h2effect').css({'opacity':1});
				//console.log("123");
				//console.log($('.h2effect').children().length);
				// for (var i = 0; i <= $('.h2effect').children().length; i++) {
				// 	$('.h2effect').children('span:eq('+i+')').delay(50*i).animate({'opacity':1},50);
				// };
			}
		});
	};

	// $('.thumbnail-link').click(function(){
	// 	lightbox_with();
	// });

	// function lightbox_with(){
	// 	$('.col-gallery .container').each(function(){
	// 		console.log("test");
	// 		var elemWidth = $('.lb-image').width();
	// 		console.log(elemWidth);
	// 		var windowHeight = $(window).width();
	// 		console.log(windowHeight);
	// 		elemWidth = windowHeight/2 + elemWidth/2;
	// 		console.log(elemWidth);
	// 		$('.lb-close').css({ left: elemWidth });
	// 	});
	// };
	
};

$(function(){
	//$('a[href^="#"]').click(function(){
	$('.btn-pagetop a').click(function(){
		var speed = 500;
		var href= $(this).attr("href");
		var target = $(href == "#" || href == "" ? 'html' : href);
		var position = target.offset().top;
		$("html, body").animate({scrollTop:position}, speed, "swing");
		return false;
	});

	$('button.btn-menu').on('click',function(){
		if($('body.modal-open').length){
			$('body').removeClass("menu");
		} else {
			$('body').addClass("menu");
		}
	});
	$('button.btn-interviewdrop').on('click',function(){
			$('body').addClass("interviewdrop");
	});
	$('button.close').on('click',function(){
		if($('body.modal-open').length){
			$('body').removeClass("interviewdrop");
		}
	});

	if ( navigator.userAgent.indexOf('iPhone') > 0 ) {
		$("body").addClass("iPhone");
	};
	if ( navigator.userAgent.indexOf('iPad') > 0 ) {
		$("body").addClass("iPad");
	};
	if ( navigator.userAgent.indexOf('Android') > 0 ) {
		$("body").addClass("Android");
	};

	//タブ切り替え
	var pills_contents = $("#pills-tab").children("li").length;
	//var contents = $("#pills-tab li").length;
	$(document).on("click", "#pills-tab a", function () {
		$('#pills-tab').find('a.active').each(function( index, value ) {
			var tab_count = value.textContent;
			if (tab_count <= 1) {
				$('#tab_prev').addClass("btn_invalid")
			} else {
				$('#tab_prev').removeClass("btn_invalid")
			}
			if (tab_count >= pills_contents-2) {
				$('#tab_next').addClass("btn_invalid")
			} else {
				$('#tab_next').removeClass("btn_invalid")
			}
		})
	});

	//戻る
	$('#tab_prev').on('click',function(){
		$('#pills-tab').find('a.active').each(function( index, value ) {
			$(this).addClass("active_point")
			var index = $('.active_point').index('#pills-tab li a');
			$(this).removeClass("active_point")
			if (index > 1) {
				$('#pills-tab li a').eq(index-1).click();
			}
		})
	});
	//進む
	$('#tab_next').on('click',function(){
		$('#pills-tab').find('a.active').each(function( index, value ) {
			$(this).addClass("active_point")
			var index = $('.active_point').index('#pills-tab li a');
			$(this).removeClass("active_point")
			if (index < pills_contents-2) {
				$('#pills-tab li a').eq(index+1).click();
			}
		})
	});
	
});

$(document).ready(function () {
    $(window).on("scroll", function () {
        var scrollHeight = $(document).height(); //ドキュメントの高さ 
        var scrollPosition = $(window).height() + $(window).scrollTop(); //現在地 
		var footHeight = $("#footercontact").innerHeight() + $("#page-footer").innerHeight() + 14; //止めたい位置の高さ
		//var footHeight = $("#footercontact").offset().top; //止めたい位置の高さ
        if (scrollHeight - scrollPosition <= footHeight) { //ドキュメントの高さと現在地の差がfooterの高さ以下の時
            $(".grecaptcha-badge").css({
				"position": "absolute", //pisitionをabsoluteに変更
				"bottom": footHeight + "px",
            });
        } else { //それ以外の場合は
            $(".grecaptcha-badge").css({
				"position": "fixed", //固定表示
				"bottom": "14px",
            });
        }
    });

});